import type { SmartActionsInputProps } from '@bitte-ai/types';
import React, { useEffect, useRef, useState } from 'react';
import { Textarea } from '../ui/textarea';
import { AgentPill } from './AgentPill';
import DefaultSendButton from './default-components/DefaultSendButtonComponent';

export const SmartActionsInput = ({
  input,
  isLoading,
  agentName,
  agentImage,
  handleChange,
  handleSubmit,
  buttonColor,
  borderColor,
  textColor,
  backgroundColor,
  mobileInputExtraButton,
  customSendButtonComponent: SendButtonComponent = DefaultSendButton,
  placeholderText,
}: SmartActionsInputProps) => {
  const agentNameRef = useRef<HTMLDivElement>(null);
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const [previousAgentName, setPreviousAgentName] =
    useState<string>('Select Agent');

  useEffect(() => {
    if (agentName && agentName !== previousAgentName) {
      setPreviousAgentName(agentName);
    }
  }, [agentName]);

  // Only sync when input is cleared externally (like after form submission)
  useEffect(() => {
    if (textareaRef.current && input === '') {
      textareaRef.current.value = '';
    }
  }, [input]);

  return (
    <form
      className="bitte-relative bitte-mb-0 bitte-flex bitte-w-full bitte-items-center bitte-justify-center bitte-gap-4 max-lg:bitte-flex-wrap"
      style={{ color: textColor }}
      onSubmit={handleSubmit}
    >
      <div className="bitte-w-full bitte-relative">
        <AgentPill
          name={agentName || previousAgentName}
          agentImage={agentImage}
          ref={agentNameRef}
        />
        <Textarea
          ref={textareaRef}
          placeholder={
            placeholderText || `Message ${agentName || 'Smart Actions'}`
          }
          style={{
            background: backgroundColor,
            borderColor: borderColor,
          }}
          className="bitte-h-[42px] bitte-pl-[45px] bitte-w-full bitte-resize-none bitte-min-h-0 textarea-chat"
          onChange={handleChange}
          onKeyDown={(e: React.KeyboardEvent<HTMLTextAreaElement>) => {
            if (e.key === 'Enter' && !e.shiftKey && !isLoading) {
              e.preventDefault();
              handleSubmit(e as unknown as React.FormEvent<HTMLFormElement>);
            }
          }}
        />
      </div>
      <div className="bitte-flex bitte-gap-2 bitte-w-full lg:bitte-contents">
        {mobileInputExtraButton ? (
          <div className="bitte-w-full lg:bitte-hidden">
            {mobileInputExtraButton}
          </div>
        ) : null}
        <SendButtonComponent
          input={input}
          isLoading={isLoading}
          buttonColor={buttonColor}
          textColor={textColor}
        />
      </div>
    </form>
  );
};
